/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Your_MobileInputs */

const en_plan_your_mobile = /** @type {(inputs: Plan_Your_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your mobile plan`)
};

const es_plan_your_mobile = /** @type {(inputs: Plan_Your_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu plan móvil`)
};

/**
* | output |
* | --- |
* | "Your mobile plan" |
*
* @param {Plan_Your_MobileInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_your_mobile = /** @type {((inputs?: Plan_Your_MobileInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Your_MobileInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_your_mobile(inputs)
	return en_plan_your_mobile(inputs)
});